import { FacilityFieldsFragment, BffFacility } from '@/graphql/__generated/sdk';

import { officePathByBrand } from './officeURLByBrand';

import { BrandThemeConfig } from '@shared-components/types';

export const getOdpUrl = (
	address: FacilityFieldsFragment['address'] | BffFacility['address'],
	config: BrandThemeConfig
) => {
	const facilityUrl = officePathByBrand(config.themeId, {
		stateStrOptions: {
			stateAbbreviation: address?.stateCode || '',
			state: '',
			city: address?.city || '',
		},
		cityAddressOptions: {
			city: address?.city || undefined,
			address: address?.address1?.replaceAll('/', '-') || undefined,
			zip: address?.zipCode || undefined,
		},
	});

	const facilityBasePath = config.features.otherApps.facilityDetailsBasePath;

	return globalThis.location?.origin && `${globalThis.location.origin}/${facilityBasePath}/${facilityUrl}/`;
};

const getOdpLinks = (odpUrl: string) => {
	return [{ id: 1, path: odpUrl, title: 'Office Details' }];
};

export function generateODPLinks(office: FacilityFieldsFragment, config: BrandThemeConfig) {
	const odpUrl = getOdpUrl(office.address, config);

	const odpLinks = getOdpLinks(odpUrl);

	return odpLinks;
}
